import React, { Component, PropTypes } from 'react';
import './selectConfiguration.scss';

// SVG files from https://github.com/encharm/Font-Awesome-SVG-PNG
import screenSvg from './screen.svg';
import remoteSvg from './remote.svg';

export default class SelectDeviceRole extends Component {

  static contextTypes = {
    deckState: PropTypes.object.isRequired,
    setDeviceRole: PropTypes.func.isRequired,
    i18n: PropTypes.func.isRequired
  }

  setDeviceRole (role, evt) {
    const { setDeviceRole } = this.context;
    setDeviceRole(role);
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.nativeEvent.stopPropagation();
    }
  }

  render () {
    const { deckState: { deviceRole }, i18n: _ } = this.context;
    return (
      <div className="select-configuration">
        <h1>{_('Select Role of This Device')}</h1>
        <div className="select-btn-container">
          <button
              className={'btn btn-lg classroomDisplayBtn ' + ((deviceRole === 'classroomDisplay') && 'active')}
              onClick={this.setDeviceRole.bind(this, 'classroomDisplay')}>
            <figure className="icons">
              <img src={screenSvg} className="screenSvg" />
            </figure>
            <div className="description">
              <h3>{_('Classroom Display')}</h3>
            </div>
            <div className="checkmark">
              {(deviceRole === 'classroomDisplay') &&
              <i className="glyphicon glyphicon-ok"></i>
              }
            </div>
          </button>
          <button
            className={'btn btn-lg remoteControlBtn ' + ((deviceRole === 'remoteControl') && 'active')}
              onClick={this.setDeviceRole.bind(this, 'remoteControl')}>
            <figure className="icons">
              <img src={remoteSvg} className="remoteSvg"/>
            </figure>
            <div className="description">
              <h3>{_('Remote Control')}</h3>
            </div>
            <div className="checkmark">
              {(deviceRole === 'remoteControl') &&
              <i className="glyphicon glyphicon-ok"></i>
              }
            </div>
          </button>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/session/presentation/components/selectDeviceRole.js